(() => {
	'use strict';
	$('#leserreporter-wrapper').on('click', '.pagination a', function (evt) {
		evt.preventDefault();
		window.ajaxNavigateTo(this.href, 'leserreporter-artikel');
		return false;
	});
})();
